import React, { useCallback } from 'react'
import { Can } from 'components/Permissions'
import { TitleStyles } from './Style'
import { useNavigate } from 'react-router-dom'

const Title = (props) => {
    const { feature, height, title, children, featurePath, featureRoute, breadcrumbs } = props

    const navigate = useNavigate()

    const navigateTo = useCallback(() => {
        if (breadcrumbs) {
            if (featureRoute)
                navigate(featureRoute.path, { state: featureRoute.state })
            else navigate(`/${featurePath}`)
        }
    }, [featurePath, breadcrumbs, featureRoute])

    return (
        <TitleStyles height={height} breadcrumbs={breadcrumbs}>
            <Can I="read" a={`${feature}-title`}>
                <h1>
                    <div className='title' onClick={navigateTo}>{title}</div>
                    <div className='title-items'>
                        {children}
                    </div>
                </h1>
            </Can>
        </TitleStyles>
    )
}

export default Title